import "./App.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Switch, Route, Routes } from "react-router-dom";
import RoutesProjects from "./routes/RoutesProjects";
import RoutesSafeAPs from "./routes/RoutesSafeAPs";
import RoutesClients from "./routes/RoutesClients";
import UpdateTemplates from "./config/UpdateTemplates";
import Login from "./components/layout/login/Login";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { UserProvider } from "./api/UserProvider";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <UserProvider>
        <>
          {/* <Routes> */}
          <RoutesProjects />
          <RoutesSafeAPs />
          <RoutesClients />
          {/* </Routes> */}

          {/* <Route exact path="/updateTemplates" element={UpdateTemplates} /> */}
        </>
        <ReactQueryDevtools initialIsOpen={false} />
      </UserProvider>
    </QueryClientProvider>
  );
}

export default App;
